import {WorksheetStatus} from "src/models/multidimensional-allocation/MultiAllocationSheetData";
import {MultiAllocationSheetValidationData} from "src/models/multidimensional-allocation/MultiAllocationSheetDetails";

/**
 * Hook to get button properties based on entity status and validation errors
 */
export const useApprovalButtonProps = (
    entityStatus: WorksheetStatus,
    onSubmitClick: () => void,
    onApprovalClick: () => void,
    validationData?: MultiAllocationSheetValidationData,
    getValidationMessage?: () => string | undefined,
    isProcessing: boolean = false
) => {
    const hasValidationErrors = validationData?.validationErrors && validationData.validationErrors.length > 0;
    const validationMessage = getValidationMessage?.();
    const hasCustomValidationError = validationMessage != null;

    switch (entityStatus) {
        case 'DRAFT_IN_PROGRESS':
            return {
                label: 'Submit for Review',
                onClick: onSubmitClick,
                disabled: isProcessing || hasValidationErrors || hasCustomValidationError,
                disabledReason: hasValidationErrors ? 'Cannot submit sheet with validation errors' : validationMessage
            };
        case 'PENDING_APPROVAL':
            return {
                label: 'Approval Decision',
                onClick: onApprovalClick,
                disabled: isProcessing,
                disabledReason: undefined
            };
        case 'ACTIVE':
            return {
                label: 'Submit for Review',
                onClick: () => {},
                disabled: true,
                disabledReason: 'Sheet is already active'
            };
        default:
            return {
                label: 'Submit for Review',
                onClick: () => {},
                disabled: true,
                disabledReason: 'Action not available'
            };
    }
};
